import { Fragment } from "react";
import { Link } from "@/router";
import { renderEmptyCellState } from "@/components/Table/utils";
import { getTaskReferenceParents, type TaskReferenceParent } from "@/features/global/components/ReferencesTable/types";
import type { CRMTask } from "@/types";

function stopRowClick(event: React.MouseEvent) {
  event.stopPropagation();
}

function ReferenceParentName({ parent }: { parent: TaskReferenceParent }) {
  if (parent.kind === "person" && parent.pgaId) {
    return (
      <Link to="/people/:pgaId" params={{ pgaId: parent.pgaId }} onClick={stopRowClick}>
        {parent.name}
      </Link>
    );
  }

  if (parent.kind === "facility" && parent.facilityId) {
    return (
      <Link to="/facilities/:facilityId" params={{ facilityId: parent.facilityId }} onClick={stopRowClick}>
        {parent.name}
      </Link>
    );
  }

  if (parent.kind === "event" && parent.eventSlug) {
    return (
      <Link to="/events/:eventSlug" params={{ eventSlug: parent.eventSlug }} onClick={stopRowClick}>
        {parent.name}
      </Link>
    );
  }

  return <>{parent.name}</>;
}

export default function ReferenceParentsCell({ references }: { references?: CRMTask["references"] }) {
  const parents = getTaskReferenceParents(references);
  if (parents.length === 0) return renderEmptyCellState(null);

  return (
    <>
      {parents.map((parent, index) => (
        <Fragment key={parent.key}>
          {index > 0 && ", "}
          <ReferenceParentName parent={parent} />
        </Fragment>
      ))}
    </>
  );
}
